import actions from '../../actionTypes';

export default location => {
  return {
    type: actions.ADD_LOCATION,
    location
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/locationAdd.js